<script>
import { DevicesService } from '@/services/devices.service';
import BaseAutocompleteFilter from '@/modules/_global/_components/filters/BaseAutocompleteFilter.vue';

export default {
  name: 'StatesFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    getData() {
      return DevicesService.getStates().then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
